import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/triangreencamp/src/app/main-presentation/components/PresentationShell.tsx");
